import { render } from "./inline-message.vue?vue&type=template&id=392f3470"
import script from "./inline-message.vue?vue&type=script&lang=js"
export * from "./inline-message.vue?vue&type=script&lang=js"

import "./inline-message.vue?vue&type=style&index=0&id=392f3470&lang=css"

import exportComponent from "/home/runner/work/iam-atkomst-web/iam-atkomst-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__